// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var DataDependency$SmartcutsMacros = require("./commands/shared/DataDependency.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    if (v === /* Empty */0) {
      return ["Empty"];
    } else {
      return ["Unknown"];
    }
  } else if (v.TAG === /* Formula */0) {
    return [
            "Formula",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "Value",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Empty" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Empty */0
                  };
          }
      case "Formula" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Formula */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Unknown" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Unknown */1
                  };
          }
      case "Value" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Value */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(value) {
  if (typeof value === "number") {
    if (value === /* Empty */0) {
      return "Empty";
    } else {
      return "Unknown";
    }
  } else if (value.TAG === /* Formula */0) {
    return "Formula(" + (value._0 + ")");
  } else {
    return "Value(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, value._0) + ")");
  }
}

function isEmpty(x) {
  if (typeof x === "number") {
    if (x === /* Empty */0) {
      return true;
    } else {
      return Util$SmartcutsMacros.logAndRaiseJsError("Cannot determine if Unknown value for cell is empty");
    }
  }
  if (x.TAG === /* Formula */0) {
    return false;
  }
  var match = x._0;
  if (match.TAG === /* StaticText */0 && match._0 === "") {
    return true;
  } else {
    return false;
  }
}

function isValueWithDataRef(value, f) {
  if (typeof value === "number" || value.TAG !== /* Value */1) {
    return false;
  } else {
    return Curry._1(f, value._0);
  }
}

function normalizeForKeyColumnComparison(v) {
  if (typeof v === "number" || v.TAG !== /* Value */1) {
    return v;
  } else {
    return {
            TAG: /* Value */1,
            _0: {
              TAG: /* StaticText */0,
              _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, v._0)
            }
          };
  }
}

function adjustAnyPasteToReferenceLastCopyCommand(lastCopyInfo, v) {
  if (typeof v === "number" || v.TAG !== /* Value */1) {
    return v;
  } else {
    return {
            TAG: /* Value */1,
            _0: Curry._2(DataDependency$SmartcutsMacros.DataRef.adjustAnyPasteToReferenceLastCopyCommand, lastCopyInfo, v._0)
          };
  }
}

function getReferencedCommandIds(cellValue) {
  if (typeof cellValue === "number") {
    return [];
  } else if (cellValue.TAG === /* Value */1) {
    return Curry._1(DataDependency$SmartcutsMacros.DataRef.getReferencedCommandIds, cellValue._0);
  } else {
    return [];
  }
}

function stringGet(cellValue) {
  if (typeof cellValue === "number") {
    if (cellValue === /* Empty */0) {
      return "";
    } else {
      return "?";
    }
  } else if (cellValue.TAG === /* Formula */0) {
    return cellValue._0;
  } else {
    return Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, cellValue._0);
  }
}

function humanize(value) {
  if (typeof value === "number") {
    if (value === /* Empty */0) {
      return "";
    } else {
      return "?";
    }
  } else if (value.TAG === /* Formula */0) {
    return value._0;
  } else {
    return Curry._1(DataDependency$SmartcutsMacros.DataRef.humanize, value._0);
  }
}

function humanizeWithConcreteValue(value) {
  if (typeof value === "number") {
    if (value === /* Empty */0) {
      return "";
    } else {
      return "?";
    }
  } else if (value.TAG === /* Formula */0) {
    return value._0;
  } else {
    return Curry._1(DataDependency$SmartcutsMacros.DataRef.humanizeWithConcreteValue, value._0);
  }
}

function fromCellData(cellData) {
  var match = cellData.effectiveValue;
  if (match !== undefined) {
    var formulaString = match.formulaValue;
    if (formulaString !== undefined) {
      return {
              TAG: /* Formula */0,
              _0: formulaString
            };
    }
    
  }
  var value = cellData.formattedValue;
  if (value !== undefined && value !== "") {
    return {
            TAG: /* Value */1,
            _0: {
              TAG: /* StaticText */0,
              _0: value
            }
          };
  } else {
    return /* Empty */0;
  }
}

function mapDataRef(f, value) {
  if (typeof value === "number") {
    if (value === /* Empty */0) {
      return /* Empty */0;
    } else {
      return /* Unknown */1;
    }
  } else if (value.TAG === /* Formula */0) {
    return {
            TAG: /* Formula */0,
            _0: value._0
          };
  } else {
    return {
            TAG: /* Value */1,
            _0: Curry._1(f, value._0)
          };
  }
}

var Value = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  isEmpty: isEmpty,
  isValueWithDataRef: isValueWithDataRef,
  normalizeForKeyColumnComparison: normalizeForKeyColumnComparison,
  adjustAnyPasteToReferenceLastCopyCommand: adjustAnyPasteToReferenceLastCopyCommand,
  getReferencedCommandIds: getReferencedCommandIds,
  stringGet: stringGet,
  humanize: humanize,
  humanizeWithConcreteValue: humanizeWithConcreteValue,
  fromCellData: fromCellData,
  mapDataRef: mapDataRef
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "from",
                t_encode(v.from)
              ],
              [
                "to_",
                t_encode(v.to_)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var from = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "from"), null));
  if (from.TAG === /* Ok */0) {
    var to_ = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "to_"), null));
    if (to_.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                from: from._0,
                to_: to_._0
              }
            };
    }
    var e = to_._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".to_" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = from._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".from" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var FromTo = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  switch (v.TAG | 0) {
    case /* FromTo */0 :
        return [
                "FromTo",
                t_encode$1(v._0)
              ];
    case /* Added */1 :
        return [
                "Added",
                t_encode(v._0)
              ];
    case /* Removed */2 :
        return [
                "Removed",
                t_encode(v._0)
              ];
    
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Added" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Added */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FromTo" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FromTo */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Removed" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Removed */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(diff) {
  switch (diff.TAG | 0) {
    case /* FromTo */0 :
        var match = diff._0;
        return "FromTo({ from: " + (stringify(match.from) + (", to: " + (stringify(match.to_) + " })")));
    case /* Added */1 :
        return "Added(" + (stringify(diff._0) + ")");
    case /* Removed */2 :
        return "Removed(" + (stringify(diff._0) + ")");
    
  }
}

function lhs(diff) {
  switch (diff.TAG | 0) {
    case /* FromTo */0 :
        return diff._0.from;
    case /* Added */1 :
        return /* Empty */0;
    case /* Removed */2 :
        return diff._0;
    
  }
}

function rhs(diff) {
  switch (diff.TAG | 0) {
    case /* FromTo */0 :
        return diff._0.to_;
    case /* Added */1 :
        return diff._0;
    case /* Removed */2 :
        return /* Empty */0;
    
  }
}

function getReferencedCommandIds$1(cellDiff) {
  switch (cellDiff.TAG | 0) {
    case /* FromTo */0 :
        var match = cellDiff._0;
        var arg = [
          match.from,
          match.to_
        ];
        return ArrayUtils$SmartcutsMacros.mapcat(getReferencedCommandIds, arg);
    case /* Added */1 :
    case /* Removed */2 :
        return getReferencedCommandIds(cellDiff._0);
    
  }
}

function humanizeDiff(diff) {
  switch (diff.TAG | 0) {
    case /* FromTo */0 :
        var match = diff._0;
        return "from " + (stringGet(match.from) + (" to " + stringGet(match.to_)));
    case /* Added */1 :
        return "to " + stringGet(diff._0);
    case /* Removed */2 :
        return "removed";
    
  }
}

var ContentDiff = {
  FromTo: FromTo,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$1,
  lhs: lhs,
  rhs: rhs,
  getReferencedCommandIds: getReferencedCommandIds$1,
  humanizeDiff: humanizeDiff
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "rowIndex",
                Decco.intToJson(v.rowIndex)
              ],
              [
                "colIndex",
                Decco.intToJson(v.colIndex)
              ],
              [
                "diff",
                t_encode$2(v.diff)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
  if (rowIndex.TAG === /* Ok */0) {
    var colIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "colIndex"), null));
    if (colIndex.TAG === /* Ok */0) {
      var diff = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "diff"), null));
      if (diff.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  rowIndex: rowIndex._0,
                  colIndex: colIndex._0,
                  diff: diff._0
                }
              };
      }
      var e = diff._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".diff" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = colIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".colIndex" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = rowIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rowIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$2(param) {
  return "{ rowIndex: " + (String(param.rowIndex) + (", colIndex: " + (String(param.colIndex) + (", diff: " + (stringify$1(param.diff) + " }")))));
}

var CellDiff = {
  ContentDiff: ContentDiff,
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$2
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "colIndex",
                Decco.intToJson(v.colIndex)
              ],
              [
                "rowIndex",
                Decco.intToJson(v.rowIndex)
              ],
              [
                "value",
                t_encode(v.value)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var colIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "colIndex"), null));
  if (colIndex.TAG === /* Ok */0) {
    var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
    if (rowIndex.TAG === /* Ok */0) {
      var value = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
      if (value.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  colIndex: colIndex._0,
                  rowIndex: rowIndex._0,
                  value: value._0
                }
              };
      }
      var e = value._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = rowIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".rowIndex" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = colIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".colIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromCellData$1(colIndex, rowIndex, cellData) {
  return {
          colIndex: colIndex,
          rowIndex: rowIndex,
          value: fromCellData(cellData)
        };
}

function stringify$3(param) {
  return "{ rowIndex: " + (String(param.rowIndex) + (", colIndex: " + (String(param.colIndex) + (", value: " + (stringify(param.value) + " }")))));
}

function isEmpty$1(param) {
  return param.value === /* Empty */0;
}

function compare(expectPaste, cell1, cell2, param) {
  var value2 = cell2.value;
  var value1 = cell1.value;
  var rowIndex1 = cell1.rowIndex;
  var colIndex1 = cell1.colIndex;
  if (rowIndex1 !== cell2.rowIndex) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: should not compare two cells at different rowIndex");
  }
  if (colIndex1 !== cell2.colIndex) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: should not compare two cells at different colIndex");
  }
  var maybeDiff;
  var exit = 0;
  var exit$1 = 0;
  if (value1 === 0) {
    if (typeof value2 === "number") {
      if (value2 === /* Empty */0) {
        maybeDiff = undefined;
      } else {
        exit$1 = 2;
      }
    } else if (value2.TAG === /* Formula */0) {
      exit$1 = 2;
    } else {
      var textAfter = value2._0;
      var exit$2 = 0;
      switch (textAfter.TAG | 0) {
        case /* StaticText */0 :
        case /* PasteText */1 :
            exit$2 = 3;
            break;
        default:
          exit$1 = 2;
      }
      if (exit$2 === 3) {
        if (expectPaste !== undefined) {
          if (textAfter._0 === expectPaste) {
            maybeDiff = {
              TAG: /* Added */1,
              _0: {
                TAG: /* Value */1,
                _0: {
                  TAG: /* PasteText */1,
                  _0: expectPaste
                }
              }
            };
          } else {
            exit = 1;
          }
        } else {
          exit$1 = 2;
        }
      }
      
    }
  } else if (value2 === 0) {
    maybeDiff = {
      TAG: /* Removed */2,
      _0: value1
    };
  } else {
    exit$1 = 2;
  }
  if (exit$1 === 2) {
    if (value1 === 0 && expectPaste === undefined) {
      maybeDiff = {
        TAG: /* Added */1,
        _0: value2
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    var exit$3 = 0;
    if (value1 === 0) {
      maybeDiff = {
        TAG: /* Added */1,
        _0: value2
      };
    } else if (Caml_obj.caml_equal(value1, value2)) {
      maybeDiff = undefined;
    } else if (expectPaste !== undefined) {
      if (typeof value1 === "number" || value1.TAG === /* Formula */0 || typeof value2 === "number" || value2.TAG === /* Formula */0) {
        exit$3 = 2;
      } else {
        var match = Curry._3(DataDependency$SmartcutsMacros.DataRef.compareRawSnapshotAndCalcUpdate, expectPaste, value1._0, value2._0);
        maybeDiff = match !== undefined ? ({
              TAG: /* FromTo */0,
              _0: {
                from: value1,
                to_: {
                  TAG: /* Value */1,
                  _0: match[0]
                }
              }
            }) : undefined;
      }
    } else {
      maybeDiff = {
        TAG: /* FromTo */0,
        _0: {
          from: value1,
          to_: value2
        }
      };
    }
    if (exit$3 === 2) {
      maybeDiff = {
        TAG: /* FromTo */0,
        _0: {
          from: value1,
          to_: value2
        }
      };
    }
    
  }
  if (maybeDiff !== undefined) {
    return {
            rowIndex: rowIndex1,
            colIndex: colIndex1,
            diff: maybeDiff
          };
  }
  
}

var WithPosition = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  fromCellData: fromCellData$1,
  stringify: stringify$3,
  isEmpty: isEmpty$1,
  compare: compare
};

var Cell = {
  Value: Value,
  CellDiff: CellDiff,
  WithPosition: WithPosition
};

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "rowIndex",
                Decco.intToJson(v.rowIndex)
              ],
              [
                "cells",
                Decco.arrayToJson(t_encode, v.cells)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
  if (rowIndex.TAG === /* Ok */0) {
    var cells = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cells"), null));
    if (cells.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                rowIndex: rowIndex._0,
                cells: cells._0
              }
            };
    }
    var e = cells._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cells" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = rowIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rowIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromRowData(rowIndex, rowData) {
  var values = rowData.values;
  var cells = values !== undefined ? $$Array.map(fromCellData, values) : [];
  return {
          rowIndex: rowIndex,
          cells: cells
        };
}

function applyCellDiff(param, row) {
  var diff = param.diff;
  var colIndex = param.colIndex;
  var rowIndex = param.rowIndex;
  if (rowIndex !== row.rowIndex) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Trying to apply a diff meant for row " + (String(rowIndex) + (" on row " + String(row.rowIndex))));
  }
  var value;
  switch (diff.TAG | 0) {
    case /* FromTo */0 :
        value = diff._0.to_;
        break;
    case /* Added */1 :
        value = diff._0;
        break;
    case /* Removed */2 :
        return {
                rowIndex: row.rowIndex,
                cells: ArrayUtils$SmartcutsMacros.updateAt(/* Empty */0, colIndex, (function (_maybeVal) {
                        return /* Empty */0;
                      }), row.cells)
              };
    
  }
  return {
          rowIndex: row.rowIndex,
          cells: ArrayUtils$SmartcutsMacros.updateAt(/* Empty */0, colIndex, (function (_maybeVal) {
                  return value;
                }), row.cells)
        };
}

function stringify$4(param) {
  return "{ rowIndex: " + (String(param.rowIndex) + (", cells: [" + ($$Array.map(stringify, param.cells).join(", ") + "]}")));
}

function isEmpty$2(param) {
  return Belt_Array.every(param.cells, isEmpty);
}

var Row = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromRowData: fromRowData,
  applyCellDiff: applyCellDiff,
  stringify: stringify$4,
  isEmpty: isEmpty$2
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.intToJson(v.id)
              ],
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "headers",
                t_encode$5(v.headers)
              ],
              [
                "rows",
                Decco.arrayToJson(t_encode$5, v.rows)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var headers = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "headers"), null));
      if (headers.TAG === /* Ok */0) {
        var rows = Decco.arrayFromJson(t_decode$5, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
        if (rows.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    name: name._0,
                    headers: headers._0,
                    rows: rows._0
                  }
                };
        }
        var e = rows._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".rows" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = headers._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".headers" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function fromSheet(sheet) {
  var gridData = sheet.data;
  var values;
  if (gridData !== undefined) {
    if (gridData.length !== 0) {
      var rowData = Caml_array.get(gridData, 0).rowData;
      values = rowData !== undefined ? ArrayUtils$SmartcutsMacros.filterMapi((function (rowIndex, rowData) {
                var row = fromRowData(rowIndex, rowData);
                if (row.cells.length !== 0) {
                  return row;
                }
                
              }), rowData) : [];
    } else {
      values = [];
    }
  } else {
    values = [];
  }
  var arg = sheet.properties;
  var sheetProperties = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect some sheet.properties");
  var arg$1 = sheetProperties.title;
  var name = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expect some properties.title");
  var arg$2 = sheetProperties.sheetId;
  var id = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
      })("Expect some properties.sheetId");
  var headers = Belt_Array.get(values, 0);
  if (headers !== undefined) {
    return {
            id: id,
            name: name,
            headers: headers,
            rows: Belt_Array.slice(values, 1, values.length - 1 | 0)
          };
  }
  
}

var Worksheet = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  fromSheet: fromSheet
};

function t_encode$7(v) {
  switch (v.TAG | 0) {
    case /* UpdateCell */0 :
        return [
                "UpdateCell",
                t_encode$3(v._0),
                t_encode$5(v._1)
              ];
    case /* AppendRow */1 :
        return [
                "AppendRow",
                t_encode$5(v._0)
              ];
    case /* DeleteRow */2 :
        return [
                "DeleteRow",
                t_encode$5(v._0)
              ];
    
  }
}

function t_decode$7(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AppendRow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$5(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AppendRow */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DeleteRow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$5(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DeleteRow */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "UpdateCell" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = t_decode$5(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* UpdateCell */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$5(sheetDiff) {
  switch (sheetDiff.TAG | 0) {
    case /* UpdateCell */0 :
        return "UpdateCell(" + (stringify$2(sheetDiff._0) + (", " + (stringify$4(sheetDiff._1) + ")")));
    case /* AppendRow */1 :
        return "AppendRow(" + (stringify$4(sheetDiff._0) + ")");
    case /* DeleteRow */2 :
        return "DeleteRow(" + (stringify$4(sheetDiff._0) + ")");
    
  }
}

function getReferencedCommandIds$2(sheetDiff) {
  switch (sheetDiff.TAG | 0) {
    case /* UpdateCell */0 :
        return getReferencedCommandIds$1(sheetDiff._0.diff);
    case /* AppendRow */1 :
    case /* DeleteRow */2 :
        return ArrayUtils$SmartcutsMacros.mapcat(getReferencedCommandIds, sheetDiff._0.cells);
    
  }
}

var SheetDiff = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  stringify: stringify$5,
  getReferencedCommandIds: getReferencedCommandIds$2
};

var Schema;

exports.Schema = Schema;
exports.Cell = Cell;
exports.Row = Row;
exports.Worksheet = Worksheet;
exports.SheetDiff = SheetDiff;
/* Util-SmartcutsMacros Not a pure module */
